import { createSlice } from "@reduxjs/toolkit";
import {
  addProcessorRamSSDMaxSequencialWrite,
  fetchProcessorSSDMaxSequqncialWrite,
  fetchProcessorSSDMaxSequentialWriteById,
  updateProcessorSSDMaxSequencialWrite,
  updateStatusInProcessorSSDMaxSequqnecialWrite,
} from "./thunk";

interface CategoryState {
  processor_ssd_max_sequqncial_list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedCategories: any;
}

const initialState: CategoryState = {
  processor_ssd_max_sequqncial_list: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedCategories: null,
};

const categorySlice = createSlice({
  name: "ssd_max_sequencial",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProcessorSSDMaxSequqncialWrite.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorSSDMaxSequqncialWrite.fulfilled, (state, action) => {
        state.loading = false;
        state.processor_ssd_max_sequqncial_list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProcessorSSDMaxSequqncialWrite.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Processor Threads";
      })
      .addCase(fetchProcessorSSDMaxSequentialWriteById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorSSDMaxSequentialWriteById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCategories = action.payload;
      })
      .addCase(fetchProcessorSSDMaxSequentialWriteById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addProcessorRamSSDMaxSequencialWrite.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_ssd_max_sequqncial_list = state.processor_ssd_max_sequqncial_list.map((ssd_max_sequencial) =>
          ssd_max_sequencial.id === action.payload.id ? action.payload : ssd_max_sequencial
        );
      })
      .addCase(addProcessorRamSSDMaxSequencialWrite.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      
      
    
      .addCase(updateProcessorSSDMaxSequencialWrite.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      });
  },
});

export default categorySlice.reducer;
